import { StyledNavItem } from './Nav.styled';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import React, { useEffect, useRef, useState } from 'react';
import Dropdown from 'components/shared/Dropdown';
import { NavItemTypes } from './Nav.types';

const TENavItem: React.FC<NavItemTypes> = ({
  options,
  href,
  label,
  isActive,
  closeMobileMenu,
  serviceEvent,
  isDownload
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const menu = useRef<HTMLDivElement>(null);

  const handleCloseMenuClick = (e: MouseEvent): void => {
    if (window.matchMedia('(min-width: 1056px)').matches) {
      if (menu.current?.contains(e.target as Node)) {
        return;
      }
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleCloseMenuClick);

    return () => {
      document.removeEventListener('mousedown', handleCloseMenuClick);
    };
  }, []);

  return (
    <StyledNavItem ref={menu}>
      {!options && href && (
        <Link href={href} passHref>
          <a
            className={isActive ? 'active' : ''}
            onClick={() => {
              closeMobileMenu ? closeMobileMenu() : null;
              serviceEvent ? serviceEvent() : null;
            }}
          >
            {label}
          </a>
        </Link>
      )}
      {!options && href && isDownload && (
        <a
          href={href}
          className={isActive ? 'active' : ''}
          onClick={() => {
            closeMobileMenu ? closeMobileMenu() : null;
            serviceEvent ? serviceEvent() : null;
          }}
        >
          {label}
        </a>
      )}
      {!href && options && (
        <>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className={isActive ? 'active' : ''}
          >
            {label}
            <FontAwesomeIcon icon={menuOpen ? faCaretUp : faCaretDown} />
          </button>
          <Dropdown
            options={options}
            isAlignLeft
            style={{ display: menuOpen ? 'block' : 'none' }}
          />
        </>
      )}
    </StyledNavItem>
  );
};

export default TENavItem;
